export default __webpack_public_path__ + "static/media/send_email.04614c3d.svg";